// @ts-nocheck

import './../../../../assets/styles/CountryCode.scss'

import { Box, DialogContent, Grid, IconButton, Typography } from '@material-ui/core'
import DialogTitle from '@material-ui/core/DialogTitle'
import { Form, Formik } from 'formik'
import { isEmpty } from 'lodash'
import PropTypes from 'prop-types'
import { useRef } from 'react'
import { ArrowRight, X } from 'react-feather'
import { useTranslation } from 'react-i18next'

import { CoreSchema } from '../../../../../clientFiles/validations'
import { UsPhoneCode } from '../../../../helpers/constants'
import { noop } from '../../../../helpers/utils'
import PersonalInfoForm from '../../../auth/register/PersonalInfoForm'
import CustomDialog from '../../../common/CustomDialog'
import FormikCheckBox from '../../../common/formikComponents/FormikCheckBox'
import LoaderButton from '../../../common/LoaderButton'
import useStyles from './PersonalInfoFormPopup.Style'

const initialState = {
  first_name: '',
  last_name: '',
  suffix: '',
  dob: '',
  gender: '',
  email: '',
  address: {
    adr_country_iso: '',
    adr_country_name: '',
    adr_state_iso: '',
    adr_state_name: '',
    adr_city: '',
    adr_zipcode: '',
    adr_address1: '',
    adr_address2: '',
    adr_mobile_prefix: UsPhoneCode,
    adr_mobile: '',
  },
  notes: '',
  infromation_agree: false,
}

function PersonalInforFormPopup({
  open,
  onClose,
  masterData,
  schooolCountries,
  searchStates,
  togglePaymentPopup,
  setFormData,
  states,
  metadata,
}) {
  const onSubmit = (values) => {
    setFormData(values)
    togglePaymentPopup()
  }
  const { t } = useTranslation()
  const countryCode = useRef('')
  const classes = useStyles()

  return (
    <CustomDialog
      paper
      className="custom-dialog guest-checkout"
      close={onClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      fullWidth={true}
      maxWidth="md"
    >
      <DialogTitle
        disableTypography
        id="customized-dialog-title"
        onClose={onClose}
        style={{ paddingBottom: 0 }}
      >
        <Box py={1} display="flex" alignItems="center" justifyContent="space-between">
          <Grid container display="flex" justifyContent="space-between">
            <Grid item xs={12} sm={8}>
              <Typography component="div" align="left" variant="h5" color="textPrimary">
                <Box width="100%" component="span" fontWeight="700" fontSize="24px">
                  {t('studentInformationForm')}
                </Box>
              </Typography>
              <Typography component="div" align="left" variant="p" color="textPrimary" gutterBottom>
                <Box
                  className="sub-title"
                  width="100%"
                  component="span"
                  fontWeight="500"
                  fontSize="12px"
                >
                  {t('fillOutGuestForm')}
                </Box>
              </Typography>
            </Grid>
          </Grid>

          {onClose ? (
            <IconButton tabIndex={-1} aria-label="close" className="close-button" onClick={onClose}>
              <X />
            </IconButton>
          ) : null}
        </Box>
      </DialogTitle>
      <DialogContent>
        <Formik
          onSubmit={onSubmit}
          initialValues={initialState}
          validationSchema={CoreSchema.guestStudentInfo}
          enableReinitialize={true}
        >
          {({ values, setFieldValue, errors, dirty }) => {
            if (
              values?.address?.adr_country_iso &&
              countryCode.current !== values?.address?.adr_country_iso
            ) {
              searchStates(values?.address?.adr_country_iso)
              countryCode.current = values?.address?.adr_country_iso
            }
            return (
              <Form className={classes.formRegister} noValidate autoComplete="off">
                <Box mb={3} mt={3}>
                  <Grid spacing={3} container display="flex">
                    <PersonalInfoForm
                      masterData={masterData}
                      values={values}
                      setFieldValue={setFieldValue}
                      metadata={metadata}
                      schooolCountries={schooolCountries}
                      states={states}
                      guestCheckout={true}
                    />
                  </Grid>
                </Box>
                <Grid item xs={12} sm={12}>
                  <Box className="custom-checkbox">
                    <FormikCheckBox
                      name="infromation_agree"
                      label={t('informationAccuracyAgreement')}
                      setFieldValue={setFieldValue}
                      checked={values.infromation_agree}
                    />
                  </Box>
                </Grid>
                <Box mb={2} width={'100%'}>
                  <Grid spacing={1} container justifyContent="space-between">
                    <Grid item xs={12} sm={7} md="auto">
                      <Typography component="div" variant="p" color="textSecondary">
                        <Box maxWidth={'500px'} fontSize={'13px'}>
                          {t('agreeToReceiveCommunication')}
                        </Box>
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={5} md="auto">
                      <Box
                        display="flex"
                        alignItems="flex-end"
                        justifyContent="flex-end"
                        width={{ xs: '100%', sm: 'auto' }}
                        mt={{ xs: '8px', sm: 'auto', md: 'auto' }}
                      >
                        <LoaderButton
                          className="text-transform-none"
                          size="large"
                          variant="contained"
                          disableElevation
                          endIcon={<ArrowRight />}
                          color="primary"
                          type="submit"
                          disabled={!isEmpty(errors) || !values.infromation_agree || !dirty}
                        >
                          {t('saveAndContinue')}
                        </LoaderButton>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Form>
            )
          }}
        </Formik>
      </DialogContent>
    </CustomDialog>
  )
}

PersonalInforFormPopup.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  masterData: PropTypes.object,
  schooolCountries: PropTypes.array,
  searchStates: PropTypes.func,
  togglePaymentPopup: PropTypes.func,
  setFormData: PropTypes.func,
  states: PropTypes.array,
  metadata: PropTypes.object,
}

PersonalInforFormPopup.defaultProps = {
  open: false,
  onClose: noop,
  masterData: {},
  schooolCountries: [],
  searchStates: noop,
  togglePaymentPopup: noop,
  setFormData: noop,
  states: [],
  metadata: {},
}

export default PersonalInforFormPopup
